import ChevronRight from '@material-ui/icons/ChevronRight';
import { RedDot } from 'assets/icons';
import cn from 'classnames';
import { t } from 'i18next';
import { FC } from 'react';
import { weekDays } from 'shared/util/utility';
import './styles.scss';

interface Props {
	newMessageTitle?: string;
	redirection: () => void;
	messageDetailRedirection: () => void;
	unreadMessageDate: string;
	unreadMessageCount: number;
	cyTestRef: string;
}

const MessageCard: FC<Props> = ({ newMessageTitle, redirection, messageDetailRedirection, unreadMessageDate, unreadMessageCount, cyTestRef }) => {
	const getMessageDay = new Date(unreadMessageDate).getDay();
	// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
	const renderMessageDay = weekDays[getMessageDay]!;
	const renderMarketingTexts = (unreadMessageCount: number) => {
		if (unreadMessageCount === 0) {
			return t('lastMessage');
		} else if (unreadMessageCount === 1) {
			return t('marketingText');
		} else {
			return t('marketingTextTwo');
		}
	};

	const renderMessagesStatus = (unreadMessageCount: number) => {
		if (unreadMessageCount === 1) {
			return t('oneNewMessage');
		} else {
			return t('moreThenOneNewMessage');
		}
	};

	return (
		<div className="MessageCard" data-cy={cyTestRef}>
			<div className="MessageCard__content" onClick={redirection}>
				<div className="MessageCard__titleSection">
					{unreadMessageCount > 0 && <RedDot />}
					<p className="MessageCard__title">{t('inbox')}</p>
				</div>
				<div className="MessageCard__status">
					{unreadMessageCount > 0 ? (
						<div className="MessageCard__statusText">
							{unreadMessageCount} {renderMessagesStatus(unreadMessageCount)}
						</div>
					) : (
						<p className="MessageCard__statusText">{t('upToDate')}</p>
					)}

					<ChevronRight />
				</div>
			</div>
			{newMessageTitle && (
				<div className="MessageCard__messageInfo">
					<p className="MessageCard__lastMessageHeader">{renderMarketingTexts(unreadMessageCount)}</p>
					<div className="MessageCard__lastMessage" onClick={messageDetailRedirection}>
						<p className={cn('MessageCard__lastMessageTitle', { MessageCard__unreadMessageTitle: unreadMessageCount })}>
							{newMessageTitle}
						</p>
						<p className="MessageCard__lastMessageDay">{`${t(renderMessageDay)}.`}</p>
					</div>
				</div>
			)}
		</div>
	);
};

export default MessageCard;
